/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppointmentsRouteImport } from './routes/appointments'
import { Route as DocumentsRouteImport } from './routes/documents'
import { Route as HelpRouteImport } from './routes/help'
import { Route as ImpersonateRouteImport } from './routes/impersonate'
import { Route as PlaidLinksRouteImport } from './routes/plaid-links'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as Sign_upRouteImport } from './routes/sign_up'
import { Route as StepsRouteImport } from './routes/steps'
import { Route as DocumentsNewRouteImport } from './routes/documents_.new'
import { Route as ISlugRouteImport } from './routes/i.$slug'
import { Route as LocationsIdRouteImport } from './routes/locations.$id'
import { Route as ProfileContactRouteImport } from './routes/profile_.contact'
import { Route as ProfileEditRouteImport } from './routes/profile_.edit'
import { Route as ProfileIdentityRouteImport } from './routes/profile_.identity'
import { Route as RepsIdRouteImport } from './routes/reps.$id'
import { Route as StepsTaskIdRouteImport } from './routes/steps_.$taskId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppointmentsRoute = AppointmentsRouteImport.update({
  id: '/appointments',
  path: '/appointments',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsRoute = DocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => rootRouteImport,
} as any)
const HelpRoute = HelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => rootRouteImport,
} as any)
const ImpersonateRoute = ImpersonateRouteImport.update({
  id: '/impersonate',
  path: '/impersonate',
  getParentRoute: () => rootRouteImport,
} as any)
const PlaidLinksRoute = PlaidLinksRouteImport.update({
  id: '/plaid-links',
  path: '/plaid-links',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const Sign_upRoute = Sign_upRouteImport.update({
  id: '/sign_up',
  path: '/sign_up',
  getParentRoute: () => rootRouteImport,
} as any)
const StepsRoute = StepsRouteImport.update({
  id: '/steps',
  path: '/steps',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentsNewRoute = DocumentsNewRouteImport.update({
  id: '/documents_/new',
  path: '/documents/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ISlugRoute = ISlugRouteImport.update({
  id: '/i/$slug',
  path: '/i/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const LocationsIdRoute = LocationsIdRouteImport.update({
  id: '/locations/$id',
  path: '/locations/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileContactRoute = ProfileContactRouteImport.update({
  id: '/profile_/contact',
  path: '/profile/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileEditRoute = ProfileEditRouteImport.update({
  id: '/profile_/edit',
  path: '/profile/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileIdentityRoute = ProfileIdentityRouteImport.update({
  id: '/profile_/identity',
  path: '/profile/identity',
  getParentRoute: () => rootRouteImport,
} as any)
const RepsIdRoute = RepsIdRouteImport.update({
  id: '/reps/$id',
  path: '/reps/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const StepsTaskIdRoute = StepsTaskIdRouteImport.update({
  id: '/steps_/$taskId',
  path: '/steps/$taskId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/appointments': typeof AppointmentsRoute
  '/documents': typeof DocumentsRoute
  '/help': typeof HelpRoute
  '/impersonate': typeof ImpersonateRoute
  '/plaid-links': typeof PlaidLinksRoute
  '/profile': typeof ProfileRoute
  '/sign_up': typeof Sign_upRoute
  '/steps': typeof StepsRoute
  '/documents/new': typeof DocumentsNewRoute
  '/i/$slug': typeof ISlugRoute
  '/locations/$id': typeof LocationsIdRoute
  '/profile/contact': typeof ProfileContactRoute
  '/profile/edit': typeof ProfileEditRoute
  '/profile/identity': typeof ProfileIdentityRoute
  '/reps/$id': typeof RepsIdRoute
  '/steps/$taskId': typeof StepsTaskIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/appointments': typeof AppointmentsRoute
  '/documents': typeof DocumentsRoute
  '/help': typeof HelpRoute
  '/impersonate': typeof ImpersonateRoute
  '/plaid-links': typeof PlaidLinksRoute
  '/profile': typeof ProfileRoute
  '/sign_up': typeof Sign_upRoute
  '/steps': typeof StepsRoute
  '/documents/new': typeof DocumentsNewRoute
  '/i/$slug': typeof ISlugRoute
  '/locations/$id': typeof LocationsIdRoute
  '/profile/contact': typeof ProfileContactRoute
  '/profile/edit': typeof ProfileEditRoute
  '/profile/identity': typeof ProfileIdentityRoute
  '/reps/$id': typeof RepsIdRoute
  '/steps/$taskId': typeof StepsTaskIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/appointments': typeof AppointmentsRoute
  '/documents': typeof DocumentsRoute
  '/help': typeof HelpRoute
  '/impersonate': typeof ImpersonateRoute
  '/plaid-links': typeof PlaidLinksRoute
  '/profile': typeof ProfileRoute
  '/sign_up': typeof Sign_upRoute
  '/steps': typeof StepsRoute
  '/documents_/new': typeof DocumentsNewRoute
  '/i/$slug': typeof ISlugRoute
  '/locations/$id': typeof LocationsIdRoute
  '/profile_/contact': typeof ProfileContactRoute
  '/profile_/edit': typeof ProfileEditRoute
  '/profile_/identity': typeof ProfileIdentityRoute
  '/reps/$id': typeof RepsIdRoute
  '/steps_/$taskId': typeof StepsTaskIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/appointments'
    | '/documents'
    | '/help'
    | '/impersonate'
    | '/plaid-links'
    | '/profile'
    | '/sign_up'
    | '/steps'
    | '/documents/new'
    | '/i/$slug'
    | '/locations/$id'
    | '/profile/contact'
    | '/profile/edit'
    | '/profile/identity'
    | '/reps/$id'
    | '/steps/$taskId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/appointments'
    | '/documents'
    | '/help'
    | '/impersonate'
    | '/plaid-links'
    | '/profile'
    | '/sign_up'
    | '/steps'
    | '/documents/new'
    | '/i/$slug'
    | '/locations/$id'
    | '/profile/contact'
    | '/profile/edit'
    | '/profile/identity'
    | '/reps/$id'
    | '/steps/$taskId'
  id:
    | '__root__'
    | '/'
    | '/appointments'
    | '/documents'
    | '/help'
    | '/impersonate'
    | '/plaid-links'
    | '/profile'
    | '/sign_up'
    | '/steps'
    | '/documents_/new'
    | '/i/$slug'
    | '/locations/$id'
    | '/profile_/contact'
    | '/profile_/edit'
    | '/profile_/identity'
    | '/reps/$id'
    | '/steps_/$taskId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppointmentsRoute: typeof AppointmentsRoute
  DocumentsRoute: typeof DocumentsRoute
  HelpRoute: typeof HelpRoute
  ImpersonateRoute: typeof ImpersonateRoute
  PlaidLinksRoute: typeof PlaidLinksRoute
  ProfileRoute: typeof ProfileRoute
  Sign_upRoute: typeof Sign_upRoute
  StepsRoute: typeof StepsRoute
  DocumentsNewRoute: typeof DocumentsNewRoute
  ISlugRoute: typeof ISlugRoute
  LocationsIdRoute: typeof LocationsIdRoute
  ProfileContactRoute: typeof ProfileContactRoute
  ProfileEditRoute: typeof ProfileEditRoute
  ProfileIdentityRoute: typeof ProfileIdentityRoute
  RepsIdRoute: typeof RepsIdRoute
  StepsTaskIdRoute: typeof StepsTaskIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/appointments': {
      id: '/appointments'
      path: '/appointments'
      fullPath: '/appointments'
      preLoaderRoute: typeof AppointmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents': {
      id: '/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof DocumentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help': {
      id: '/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof HelpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/impersonate': {
      id: '/impersonate'
      path: '/impersonate'
      fullPath: '/impersonate'
      preLoaderRoute: typeof ImpersonateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plaid-links': {
      id: '/plaid-links'
      path: '/plaid-links'
      fullPath: '/plaid-links'
      preLoaderRoute: typeof PlaidLinksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign_up': {
      id: '/sign_up'
      path: '/sign_up'
      fullPath: '/sign_up'
      preLoaderRoute: typeof Sign_upRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/steps': {
      id: '/steps'
      path: '/steps'
      fullPath: '/steps'
      preLoaderRoute: typeof StepsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents_/new': {
      id: '/documents_/new'
      path: '/documents/new'
      fullPath: '/documents/new'
      preLoaderRoute: typeof DocumentsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/i/$slug': {
      id: '/i/$slug'
      path: '/i/$slug'
      fullPath: '/i/$slug'
      preLoaderRoute: typeof ISlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/locations/$id': {
      id: '/locations/$id'
      path: '/locations/$id'
      fullPath: '/locations/$id'
      preLoaderRoute: typeof LocationsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile_/contact': {
      id: '/profile_/contact'
      path: '/profile/contact'
      fullPath: '/profile/contact'
      preLoaderRoute: typeof ProfileContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile_/edit': {
      id: '/profile_/edit'
      path: '/profile/edit'
      fullPath: '/profile/edit'
      preLoaderRoute: typeof ProfileEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile_/identity': {
      id: '/profile_/identity'
      path: '/profile/identity'
      fullPath: '/profile/identity'
      preLoaderRoute: typeof ProfileIdentityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reps/$id': {
      id: '/reps/$id'
      path: '/reps/$id'
      fullPath: '/reps/$id'
      preLoaderRoute: typeof RepsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/steps_/$taskId': {
      id: '/steps_/$taskId'
      path: '/steps/$taskId'
      fullPath: '/steps/$taskId'
      preLoaderRoute: typeof StepsTaskIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppointmentsRoute: AppointmentsRoute,
  DocumentsRoute: DocumentsRoute,
  HelpRoute: HelpRoute,
  ImpersonateRoute: ImpersonateRoute,
  PlaidLinksRoute: PlaidLinksRoute,
  ProfileRoute: ProfileRoute,
  Sign_upRoute: Sign_upRoute,
  StepsRoute: StepsRoute,
  DocumentsNewRoute: DocumentsNewRoute,
  ISlugRoute: ISlugRoute,
  LocationsIdRoute: LocationsIdRoute,
  ProfileContactRoute: ProfileContactRoute,
  ProfileEditRoute: ProfileEditRoute,
  ProfileIdentityRoute: ProfileIdentityRoute,
  RepsIdRoute: RepsIdRoute,
  StepsTaskIdRoute: StepsTaskIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
